import { render } from "./pricing.vue?vue&type=template&id=d822ec9e&scoped=true"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"

import "./pricing.vue?vue&type=style&index=0&id=d822ec9e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d822ec9e"]])

export default __exports__